export const MessageTypes = {
  Success: "ReceiveSuccessNotification",
  Error: "ReceiveErrorNotification",
  Warning: "ReceiveWarningNotification",
  Info: "ReceiveInfoNotification",
  Message: "ReceiveGeneralNotification",
  ReFetchRoomReservations: "ReceiveUpdateRoomReservations",
  ReFetchCarReservations: "ReceiveUpdateCarReservations",
  WorklogsLockChanged: "ReceiveWorklogsLockChanged",
};
